import { ConversationStatus } from '@provision/conversation-types';
import { useMemo } from 'react';
import { isNullish } from 'remeda';
import { useMergeTargetSearch } from 'src/components/MergeTargetPicker/use-merge-target-search';
import { Conversation } from 'src/graphql';
import { ConditionInput, EntityNames } from 'src/graphql/types';

const SEARCH_TARGET_ATTRIBUTE_IDS = [
  'conversation/conversationId',
  'client/conversationParticipant/requesterForConversations/conversationId',
  'clientPhoneNumber/client/addresses/associatedConversations/conversationId',
  'clientEmail/client/addresses/associatedConversations/conversationId',
  'address/associatedConversations/conversationId',
  'client/conversationParticipant/conversationChannels/participations/conversationId',
];

/** Open conversations of the origin's partner, the origin itself excluded. */
export const useConversationTargetSearch = (origin?: Conversation) => {
  const partnerId = origin?.partnerId;
  const originId = origin?.id;

  const conditions = useMemo(() => {
    const list: ConditionInput[] = [
      {
        attribute: 'conversationStatusId',
        operator: '!=',
        value: ConversationStatus.Closed,
      },
    ];

    if (!isNullish(partnerId)) {
      list.push({ attribute: 'partnerId', operator: '=', value: partnerId.toString() });
    }

    if (originId) {
      list.push({ attribute: 'conversationId', operator: 'not_in', value: originId });
    }

    return list;
  }, [partnerId, originId]);

  return useMergeTargetSearch({
    entityName: EntityNames.Conversation,
    conditions,
    targetIdAttributes: SEARCH_TARGET_ATTRIBUTE_IDS,
  });
};
